/**
 * Constants
 * */
export const moduleName = `onPlatform`;

/**
 * Reducer
 * */

export default function reducer(state = ``, action) {
  const {type} = action;

  switch (type) {
    default:
      return state;
  }
}

/**
 * Selectors
 * */

export const onPlatformSelector = (state) => state[moduleName];

/**
 * Action Creators
 * */
